/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';

const StepContext = createContext({
  currentStep: '',
  currentMainStep: '',
  schema: [
    {
      id: '',
      slug: '',
    },
  ],
  prevStep: '',
  nextStep: '',
  isLastStep: false,
  shouldBackendValidate: false,
  saveGoalSettings: (values: any) => {},
  validateGoalSettings: (values: any) => {},
});

export default StepContext;
